import {authorized} from "./ApiClient";
import {AuditFilter, AuditPage} from "./models";

// The audit trail (SiteAdmin), newest first, a page at a time: pass the last page's nextBefore as before.
export const AuditApi = {
    query: (filter: AuditFilter, before?: string) => {
        const params = new URLSearchParams();
        for (const [name, value] of Object.entries({ ...filter, before })) {
            if (value !== undefined && value !== '' && value !== false) {
                params.set(name, String(value));
            }
        }
        const query = params.toString();
        return authorized<AuditPage>('GET', query ? `/audit-log?${query}` : '/audit-log');
    }
};
